// Determine environment based on hostname, not NODE_ENV
const isProd = window.location.hostname === 'rsltesting.nike.com';

export const oAuthConfig = {
  issuer: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7',
  clientId: isProd ? 'nike.gsm.rsltest' : 'nike.gsm.rsltestnonprod',
  redirectUriProd: 'https://rsltesting.nike.com',
  responseType: 'id_token token',
  scope: 'openid profile email address phone offline_access',
  redirectUri: window.location.origin,
  authorizationUrlProd: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize',
  OktaTokenUrlProd:'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/token',
  allowedIdleTime: 1800000 // (milliseconds) Value should be below 1 hour(Current OKTA token expiration time). This is the time by which application will wait for before labelling user as inactive.

};

export const oidc = {
  issuer: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7',
  //clientId: 'nike.niketech.aether',
  clientId: isProd ? 'nike.gsm.rsltest' : 'nike.gsm.rsltestnonprod',
  scope: 'openid profile email address phone offline_access',
  redirectUri: window.location.origin+ '/implicit/callback',
  pkce: true,
  tokenManager :{
    autoRenew:true,
    auto_renew:true
  }
};

